import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import { styled } from '@zenbusiness/zui/styles';

export const PrintedBox = styled(Box)(() => ({
  '@media print': {
    paddingTop: '12px',
    paddingLeft: '16px',
    paddingRight: '16px'
  }
}));

export const ButtonStyled = styled(Button)(({ theme }) => ({
  width: '100%',
  backgroundColor: 'transparent',
  border: `1px solid ${theme.palette.fixed.black}`
}));

export const WrapperStyle = ({ theme }) => ({
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '1 / 13'
  }
});
